import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  style: {"width":"100%","height":"100%"},
  class: "overflow-auto pb-16px"
}
const _hoisted_2 = {
  key: 0,
  class: "element-list"
}

import { onMounted, ref } from 'vue'
import { ElInput, ElButton, ElCascader, ElIcon } from 'element-plus'
import { ArrowDown, Search, ArrowLeft } from '@element-plus/icons-vue'
import { } from '@/api/affairs'
// @ts-ignore
import elementItem from './elementItem.vue'
// @ts-ignore
import elementlist from './elementlist.vue'
// @ts-ignore
import CollectList from './collectList.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'collect',
  emits: ["back"],
  setup(__props, { emit: __emit }) {

const elementListShow = ref(false)
const searchShow = ref(true)
const emit = __emit
const handleBack = () => {
  emit('back')
}
const categoryopt = ref({})

onMounted(() => {

})


const handleMoreClick = (item) => {
  elementListShow.value = true
  console.log('item', item)
  categoryopt.value = item
}
const getimage = (val) => {

}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "header flex items-center gap-8px mb-12px cursor-pointer",
        onClick: handleBack
      }, [
        _createVNode(_unref(ElIcon), { class: "back-icon cursor-pointer" }, {
          default: _withCtx(() => [
            _createVNode(_unref(ArrowLeft))
          ]),
          _: 1
        }),
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "title" }, "合集", -1))
      ]),
      _createVNode(CollectList, {
        showNum: 0,
        onSelectMore: handleMoreClick
      })
    ], 512), [
      [_vShow, elementListShow.value == false]
    ]),
    (elementListShow.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(elementlist, {
            categoriesShow: false,
            category: categoryopt.value,
            onBack: _cache[0] || (_cache[0] = ($event: any) => (elementListShow.value = false)),
            type: "collect"
          }, null, 8, ["category"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})